/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { AuthError } from '@stores/auth/errors';

/**
 * Empty placeholder function, usually used for error omits.
 */
/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export const noop = (): void => {};

export const wait = (ms: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(() => resolve(), ms);
  });

export const executeWhenNotAuthError = async <T extends (...args: any) => Promise<any>>(
  e,
  fn: T
): Promise<ReturnType<T> | void> => {
  if (!(e instanceof AuthError)) {
    return await fn();
  }

  return;
};
